export class InsufficientInformationException extends Error {
  constructor(message = 'Insufficient information to generate a reachout message') {
    super(message);
    this.name = 'InsufficientInformationException';
  }
}
